import {Tooltip} from "rsuite";
import React from "react";

const textStyle = {
  fontSize: 14,
  lineHeight: 1,
}

const p1Style = {
  marginBottom: 5,
  paddingBottom: 0,
  marginTop: 10
}
export const tooltip = (
  <Tooltip>
    <p style={{...textStyle, ...p1Style}}>
      Click here to assign devices to a patient/room, or make changes to patient information and room assignments.
    </p>
  </Tooltip>
);